import { render, staticRenderFns } from "./ProductLicenseTemplateIndex.vue?vue&type=template&id=0cb1b013&scoped=true&"
import script from "./ProductLicenseTemplateIndex.vue?vue&type=script&lang=js&"
export * from "./ProductLicenseTemplateIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProductLicenseTemplateIndex.vue?vue&type=style&index=0&id=0cb1b013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb1b013",
  null
  
)

export default component.exports